module.exports = __webpack_public_path__ + "static/DarksideDetective3-e9da8646c467daff0057acfb8fd4d2f3.png";